import { createSlice, createAsyncThunk, current } from '@reduxjs/toolkit';
import { empty_pagination } from '../../constants/empty_pagination';
import Agent from '../agent';

const initialState = {
  loading: false,
  spotBalances: [],
  _spotBalances: {},
  mappedBalances: [],
  spotBalancesHistory: [],
  spotBalance: [],
  mappedAssets: [],
  pagination: { pages: 0 },
  errors: {},
  redirectTo: null,
  success: false,
  message: '',
};

// These are redux/toolkit async thunk for performing api call
// There methods are automatically attached to reducers and actions below
export const getSpotBalances = createAsyncThunk(
  'exchange/spotBalances/get',
  async (payload, { rejectWithValue }) => {
    try {
      return await (
        await Agent.Exchange.SpotBalance.get(payload)
      ).data;
    } catch (err) {
      let error = err;
      if (!error.response) {
        return rejectWithValue({ errors: { [err.name]: err.message } });
      }
      return rejectWithValue(error.response.body);
    }
  }
);

export const getSpotBalanceByAccount = createAsyncThunk(
  'exchange/spotBalances/:id',
  async (payload, { rejectWithValue }) => {
    try {
      const { account, ...query } = payload;
      const { data } = await Agent.Exchange.SpotBalance.getByAccount(account, query);
      return data;
    } catch (err) {
      let error = err;
      if (!error.response) {
        return rejectWithValue({ errors: { [err.name]: err.message } });
      }
      return rejectWithValue(error.response.body);
    }
  }
);

const SpotBalancesSlice = createSlice({
  name: 'ExchangeSpotBalances',
  initialState,
  reducers: {
    setLoading(state) {
      state.success = false;
      state.loading = true;
    },
  },
  extraReducers: {
    // these are the actions generated by the above createAsyncThunk of redux/toolkit
    [getSpotBalances.pending]: (state) => {
      state.success = false;
      state.loading = true;
    },

    [getSpotBalances.fulfilled]: (state, action) => {
      let pagination = action?.payload?.pagination || empty_pagination;
      let balances = action?.payload?.data?.spot_balances || [];
      let mappedbalances = action?.payload?.data?.mapped_balances || [];

      state.success = false;
      state.loading = false;

      // state.spotBalances =
      //   pagination.currentPage > 1
      //     ? [...state.spotBalances, ...balances]
      //     : balances;

      state.mappedBalances =
        pagination.currentPage > 1 ? [...state.mappedBalances, ...mappedbalances] : mappedbalances;

      // state.pagination = pagination;

      /**
       * Sometimes second page is loaded before first page so handle this issue :
       *  If current page of pagination from API is greater than state's current page, save current page from API.
       */
      // state.pagination =
      //   pagination.currentPage > (state.pagination.currentPage || 0)
      //     ? pagination
      //     : state.pagination;

      state.pagination = pagination;
      state._spotBalances[pagination.currentPage] = balances;

      /**
       * Current: takes a snapshot of the current state of a draft and finalizes it (but without freezing).
       */
      const spotBalancesArray = current(state._spotBalances);

      let sortedWalletArray = [];

      /**
       * Loop through pages of object containing array of wallets.
       * FIXED: unarranged data in table list gets set when pages are not loaded serially.
       */
      for (let i = 1; i <= state?.pagination?.currentPage; i++) {
        if (spotBalancesArray[i]) {
          sortedWalletArray = [...sortedWalletArray, ...spotBalancesArray[i]];
        }
      }

      state.spotBalances = sortedWalletArray;
    },

    [getSpotBalances.rejected]: (state, action) => {
      state.loading = false;
      state.errors = action?.payload?.errors || {};
      state.success = false;
    },

    // these are the actions generated by the above createAsyncThunk of redux/toolkit
    [getSpotBalanceByAccount.pending]: (state) => {
      state.loading = true;
      state.success = false;
    },

    [getSpotBalanceByAccount.fulfilled]: (state, action) => {
      state.loading = false;
      state.success = false;
      let assets = action?.payload?.data?.assets || [];
      let mappedassets = action?.payload?.data?.mapped_assets || [];

      state.spotBalance = assets;
      state.mappedAssets = mappedassets;
    },

    [getSpotBalanceByAccount.rejected]: (state, action) => {
      state.loading = false;
      state.errors = action?.payload?.errors || {};
      state.success = false;
    },
  },
});

export const SpotBalancesSelector = (state) => state.exchangeSpotBalances;

export const { reducer, actions } = SpotBalancesSlice;
